// Crew — labelled form controls (Agent B). Accessible: label tied to control.
import type { InputHTMLAttributes, ReactNode, SelectHTMLAttributes } from 'react';
import { useId } from 'react';

interface TextFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  hint?: string;
}

const CONTROL =
  'mt-1 w-full rounded-xl2 border-0 bg-sand-50 px-4 py-3 text-ink-900 ring-1 ring-inset ring-sand-200 ' +
  'placeholder:text-ink-700/40 focus:ring-2 focus:ring-inset focus:ring-coral-500';

export function TextField({ label, hint, id, className = '', ...rest }: TextFieldProps) {
  const generated = useId();
  const fieldId = id ?? generated;
  return (
    <div className={className}>
      <label htmlFor={fieldId} className="block text-sm font-medium text-ink-800">
        {label}
      </label>
      <input id={fieldId} className={CONTROL} {...rest} />
      {hint && <p className="mt-1 text-xs text-ink-700/70">{hint}</p>}
    </div>
  );
}

interface SelectFieldProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  children: ReactNode;
}

export function SelectField({ label, id, className = '', children, ...rest }: SelectFieldProps) {
  const generated = useId();
  const fieldId = id ?? generated;
  return (
    <div className={className}>
      <label htmlFor={fieldId} className="block text-sm font-medium text-ink-800">
        {label}
      </label>
      <select id={fieldId} className={CONTROL} {...rest}>
        {children}
      </select>
    </div>
  );
}
